export const leverages = [
  { value: '0', text: 'reset limit' },
  { value: '1', text: '1' },
  { value: '2', text: '2' },
  { value: '20', text: '20' },
  { value: '50', text: '50' },
  { value: '100', text: '100' },
  { value: '200', text: '200' },
  { value: '400', text: '400' },
  { value: '500', text: '500' },
  { value: '600', text: '600' },
  { value: '800', text: '800' },
  { value: '1000', text: '1000' },
  { value: '2000', text: '2000' },
  { value: '210000000', text: 'unlimited' },
]
